import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import leftCurve from '../../assets/img/form/left-curve.png';
import rightCurve from '../../assets/img/form/right-curve.png';
import moleculePattern from '../../assets/img/form/molecule.png';

const QuoteForm = ({ customStyle = {} }) => {
  useEffect(() => {
    emailjs.init("vqqGcKG3votgUxn0l");
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: '',
    requirements: '',
    userAnswer: ''
  });

  const [captcha, setCaptcha] = useState({ n1: 0, n2: 0, result: 0 });
  const [isLoading, setIsLoading] = useState(false);

  const generateCaptcha = () => {
    const n1 = Math.floor(Math.random() * 10) + 1;
    const n2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha({ n1, n2, result: n1 + n2 });
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (parseInt(formData.userAnswer) !== captcha.result) {
      Swal.fire({ icon: 'error', title: 'Retry 🤖', text: 'Captcha is incorrect.' });
      generateCaptcha();
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch('https://scantobimservice.us/api/send-email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();

      if (result.status === 'success') {
        Swal.fire({ icon: 'success', title: 'Great! 😊✨', text: 'Enquiry received successfully.' });
        setFormData({ name: '', email: '', phone: '', country: '', requirements: '', userAnswer: '' });
        generateCaptcha();
      } else {
        throw new Error(result.message || 'Unknown server error');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Connection Issue ⚠️',
        text: `The server could not be reached. Error: ${error.message}`
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="quote-form-section" style={customStyle}>
      <div className="container">
        <div className="floating-form">
          <div className="form-inner-container">
            <div className="form-header">
              <h3 className="form-title">Get a Free Quote</h3>
              <p className="form-subtitle">24 Hours. That's all it will take you to figure out the cost benefits of outsourcing!</p>
            </div>

            <form className="form-inputs" onSubmit={handleSubmit}>
              <div className="input-group">
                <input type="text" name="name" placeholder="Name" className="form-input" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="input-group">
                <input type="email" name="email" placeholder="Email" className="form-input" value={formData.email} onChange={handleChange} required />
              </div>
              <div className="input-group">
                <input type="tel" name="phone" placeholder="Phone Number" className="form-input" value={formData.phone} onChange={handleChange} required />
              </div>
              <div className="input-group">
                <input type="text" name="country" placeholder="Country" className="form-input" value={formData.country} onChange={handleChange} required />
              </div>
              <div className="input-group">
                <input type="text" name="requirements" placeholder="Enter Your Requirements" className="form-input" value={formData.requirements} onChange={handleChange} required />
              </div>

              <div className="captcha-and-submit-group">
                <span className="captcha-label">Please solve {captcha.n1} + {captcha.n2}?</span>
                <div className="actions-row">
                  <input type="number" name="userAnswer" placeholder="Your Answer" className="form-input captcha-input" value={formData.userAnswer} onChange={handleChange} required />
                  <button type="submit" className="form-submit" disabled={isLoading}>
                    {isLoading ? 'Sending...' : 'Submit'}
                  </button>
                </div>

                <p className="form-footer-inline">To upload files, please use our <a href="#" className="contact-link">contact form</a></p>
              </div>
            </form>
          </div>

          <div className="side-curve left-curve" style={{ backgroundImage: `url(${leftCurve.src || leftCurve})` }}></div>
          <div className="side-curve right-curve" style={{ backgroundImage: `url(${rightCurve.src || rightCurve})` }}></div>
          <div className="form-pattern-overlay" style={{ backgroundImage: `url(${moleculePattern.src || moleculePattern})` }}></div>
        </div>
      </div>
    </section>
  );
};

export default QuoteForm;
